(function ($) {

    function init_open_review_sidebar() {
        $(".review-card button").off().on("click", function () {
            const context = $(this).data("modal-context")
            if (!context || !context.review_id || !context.review_type){
                return
            }

            $(document).trigger(
                'open_modal',
                [
                    'my-account-' + context.review_type + '-review',
                    {
                        review_id: context.review_id,
                    },
                    true
                ]
            )
        })
    }

    $(document).gp_ready(init_open_review_sidebar)

})(jQuery);